import { AutogenModelOrderStop, AutogenRowOrderStop } from "./autogen/AutogenModelOrderStop";

export class ModelOrderStop extends AutogenModelOrderStop<RowOrderStop> {
    constructor() {
        super(RowOrderStop);
    }
}

export class RowOrderStop extends AutogenRowOrderStop {
}